import Fuse from 'fuse.js'
import { useCallback, useMemo } from 'react'

export const useFuzzySearch = <T>(items: Array<T>, options: Fuse.IFuseOptions<T> = {}) => {
  const fuse = useMemo(() => new Fuse(items, options), [items, options])

  return useCallback(
    (query: string) => {
      return fuse.search(query).map(({ item }) => item)
    },
    [fuse]
  )
}
